import { css } from "@web/helpers/webComponents";

const styles: string = css`
    
    :host {
        position: absolute;
    }

    /* ending dialog */
    dialog {
        position: fixed;
        inset: 0;
        width: 100vw;
        height: 100vh;
        background-color: #000;
        
        background-size: cover;

        opacity: 0;
        animation: fadeIn 3s ease-out forwards;
    }

    dialog:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.9);
        z-index: -1;

        opacity: 0;
        animation: fadeIn 3s ease-out forwards;
    }
    
    dialog .ending-text {
        opacity: 0;
        transform: translateY(0px);
        animation: slideDown 4s ease-out 3s forwards;
        position: absolute;
        top: 50%;
        left: 50%;
        translate: -50% -50%;
        
        text-align: center;
        color: white;
    }
    
    /* button */

    a {
        text-decoration: none;
        color: inherit;
        font-weight: 500;
    }

    .buttons-container {
        display: flex;
        gap: 2rem;
    }

    button {
        position: absolute;
        bottom: 2rem;
        left: 50%;
        translate: -50% 0;
        
        font-family: "F3270 Semi-Condensed", sans-serif;
        font-size: 2rem;
        padding: 0.5rem 1.0rem;
        background-color: var(--color-blood-red);
        color: var(--button-color);
        border: none;
        border-radius: 0.4rem;
        cursor: pointer;
        text-decoration: none;
        text-transform: uppercase;

        animation: slideDown 8s ease-out 0s forwards;
        transition: opacity var(--button-hover-transition-duration) ease-out;
    }
    
    button:focus-visible {
        outline: none;
        border: none;
    }

    button:hover {
        opacity: 0.8;
    }

    /* animations */

    @keyframes slideDown {
        0% {
            opacity: 0;
            transform: translateY(-40px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        10% {
            opacity: 0.95;
        }
        90% {
            opacity: 0.95;
        }
        100% {
            opacity: 1;
        }
    }


`;

/**
 * A screen with a fade to black + fade into broken reactor background image with a scary quote
 *
 * @author Kyrylo Maliuha
 */
export class GameOverQuoteScreen extends HTMLElement {
    // Quotes taken from:
    // https://www.imdb.com/title/tt9166678/quotes/
    // https://en.wikiquote.org/wiki/Chernobyl_(miniseries)
    private readonly _quotes: string[] = [
        "The atom is a humbling thing. (c) - Valery Legasov, from Chornobyl (miniseries)",
        "You did not succeed in stopping the disaster.",
        "The world is not going to end. But it will be changed. Forever.",
    ];

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        this.shadowRoot.innerHTML = `
            <style>${styles}</style>
             <dialog id="ending">
                 <p class="ending-text">
                    ${this._quotes[Math.floor(Math.random() * this._quotes.length)]}
                 </p>
                 <div class="buttons-container">
<!--                 TODO: call an API endpoint to reset the session instead-->
                    <button class="start" onclick="localStorage.clear()">
                        <a href="./game.html">New game</a>
                    </button>
                </div>
             </dialog>
        `;
    }
}

customElements.define("game-over-quote-screen", GameOverQuoteScreen);
